module.exports = __webpack_public_path__ + "img/gnsh.8f0a8e06.png";